import { GenericDialog } from "@/components/dialogs";
import { ScopeOfWorkPrintOptions } from "@/api/williams/report";
import { useState } from "react";

export type PrintDialogProps = {
  onAccept: (options: ScopeOfWorkPrintOptions) => void;
};

export function PrintDialog({ onAccept }: PrintDialogProps) {
  const [options, setOptions] = useState<ScopeOfWorkPrintOptions>({
    summary: true,
    advisories: false,
    rangeQualifiedSummary: false,
    welderCertifications: false,
    continuityReport: false,
  });

  function handleSelectionChanged(e: React.ChangeEvent<HTMLInputElement>) {
    setOptions((prev) => ({
      ...prev,
      [e.target.id]: e.target.checked,
    }));

    if (e.target.id === "summary" && !e.target.checked) {
      setOptions((prev) => ({
        ...prev,
        advisories: false,
      }));
    }
  }

  return (
    <GenericDialog
      caption="Select items to print"
      buttons="OKCancel"
      onAccept={() => onAccept(options)}
      allowAccept={Object.entries(options).some(([, value]) => value)}
    >
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="summary"
          checked={options.summary}
          onChange={handleSelectionChanged}
        />
        <label className="form-check-label" htmlFor="summary">
          SOW Summary
        </label>
      </div>
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="advisories"
          checked={options.advisories}
          onChange={handleSelectionChanged}
          disabled={!options.summary}
        />
        <label className="form-check-label" htmlFor="advisories">
          SOW Advisories
        </label>
      </div>
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="rangeQualifiedSummary"
          checked={options.rangeQualifiedSummary}
          onChange={handleSelectionChanged}
        />
        <label className="form-check-label" htmlFor="rangeQualifiedSummary">
          Range Qualified Summary
        </label>
      </div>
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="welderCertifications"
          checked={options.welderCertifications}
          onChange={handleSelectionChanged}
        />
        <label className="form-check-label" htmlFor="welderCertifications">
          Welder Certifications
        </label>
      </div>
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="continuityReport"
          checked={options.continuityReport}
          onChange={handleSelectionChanged}
        />
        <label className="form-check-label" htmlFor="continuityReport">
          Continuity Report
        </label>
      </div>
    </GenericDialog>
  );
}
